import { RouterType } from '@online-webinar/router';
import { WebinarAttachments } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/attachments'].update({
        staticData: { title: { page: 'Content.Attachments.PageHeading', forWebinar: true } },
        component: authGuard(WebinarAttachments, { canBroadcast: true })
    });
};
